import { GET_BARGAINS } from './index';
import { GET_BARGAIN_COUNT } from './index';

export const getBargains = token => dispatch => {
    fetch(process.env.REACT_APP_GET_BARGAINS, { method: 'GET', headers: { Authorization: `Bearer ${token}` } }).then(result => result.json()).then(json => {
        dispatch({
            type: GET_BARGAINS,
            payload: {
                bargainsLoading: false,
                bargains: json
            }
        })
    })
}

export const getBargainCount = () => dispatch => {
    fetch(process.env.REACT_APP_GET_BARGAIN_COUNT).then(res => res.json()).then(data => {
        dispatch({
            type: GET_BARGAIN_COUNT,
            payload: {
                bargainCount: data.count
            }
        })
    });
}